import React, { useMemo } from 'react'

import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import noDataToDisplay from 'highcharts/modules/no-data-to-display'

noDataToDisplay(Highcharts)

function Chart({ options, children, ...props }) {
  const highchartsReactOptions = useMemo(
    () => ({
      credits: {
        enabled: false,
      },
      noData: {
        position: {
          x: 0,
          y: 0,
          align: 'center',
          verticalAlign: 'middle',
        },
      },
      ...options,
    }),
    [options],
  )

  return (
    <HighchartsReact
      {...props}
      highcharts={Highcharts}
      options={highchartsReactOptions}
    />
  )
}

export default Chart
